var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.tariff.name)?_c('div',{staticClass:"top_actions__detail_wrapper"},[_c('RightContainerNew',{attrs:{"showContinue":false,"buyButtonForTopAction":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }